module.exports = __webpack_public_path__ + "static/img/topFloor.c19bcdc8.png";